import { render, staticRenderFns } from "./AppAdminBilling.vue?vue&type=template&id=5099575a&scoped=true&"
import script from "./AppAdminBilling.vue?vue&type=script&lang=js&"
export * from "./AppAdminBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5099575a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VScrollXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VScrollXTransition})
